import { AlphaWBoxOutlineIcon } from './AlphaWBoxOutlineIcon';

/**
 * author: Contributors
 * id B844FAFE-5491-4441-9C3E-23F2AB148E10
 * name alpha-w-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-w-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterWBoxOutlineIcon = AlphaWBoxOutlineIcon;
export default LetterWBoxOutlineIcon